import React from "react";

const ThirdParty = () => {
  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <h1 style={styles.heading}>Third-Party Software Licenses</h1>

        <p style={styles.paragraph}>
          To enable a seamless browsing experience for our customers, we rely on
          the use of third-party libraries and software. These third-party
          libraries and software are governed by their own usage policies,
          declarations, and privacy policies.
        </p>

        <p style={styles.paragraph}>
          Your use of ReUrja.com website automatically mandates you to follow the
          terms and conditions, governing rules, regulations, declarations, and
          privacy policies applicable under these third-party libraries and
          software. You may find the details at the links listed below.
        </p>

        <p style={styles.subHeading}>
          Third-party software libraries and components – Terms, Privacy
          Policies, and License References:
        </p>

        <ul style={styles.list}>
          <li>
            <a
              href="https://mui.com/"
              target="_blank"
              rel="noreferrer"
              style={styles.link}
            >
              Material UI
            </a>{" "}
            –{" "}
            <a
              href="https://mui.com/legal/"
              target="_blank"
              rel="noreferrer"
              style={styles.link}
            >
              License
            </a>
          </li>

          <li>
            <a
              href="https://github.com/remix-run/react-router"
              target="_blank"
              rel="noreferrer"
              style={styles.link}
            >
              React Router
            </a>{" "}
            –{" "}
            <a
              href="https://github.com/remix-run/react-router?tab=MIT-1-ov-file#readme"
              target="_blank"
              rel="noreferrer"
              style={styles.link}
            >
              MIT License
            </a>
          </li>

          <li>
            <a
              href="https://github.com/dozoisch/react-google-recaptcha"
              target="_blank"
              rel="noreferrer"
              style={styles.link}
            >
              React Google reCAPTCHA
            </a>{" "}
            –{" "}
            <a
              href="https://github.com/dozoisch/react-google-recaptcha?tab=MIT-1-ov-file#readme"
              target="_blank"
              rel="noreferrer"
              style={styles.link}
            >
              MIT License
            </a>
          </li>

          <li>
            <a
              href="https://www.svgrepo.com/page/licensing/"
              target="_blank"
              rel="noreferrer"
              style={styles.link}
            >
              SVG Repo Licensing
            </a>
          </li>

          <li>
            <a
              href="https://github.com/facebook/react/blob/main/LICENSE"
              target="_blank"
              rel="noreferrer"
              style={styles.link}
            >
              React – License
            </a>
          </li>

          <li>
            <a
              href="https://github.com/SheetJS/sheetjs"
              target="_blank"
              rel="noreferrer"
              style={styles.link}
            >
              SheetJS (XLSX)
            </a>{" "}
            –{" "}
            <a
              href="https://github.com/SheetJS/sheetjs?tab=Apache-2.0-1-ov-file#readme"
              target="_blank"
              rel="noreferrer"
              style={styles.link}
            >
              Apache 2.0 License
            </a>
          </li>

          <li>
            <a
              href="https://github.com/uuidjs/uuid"
              target="_blank"
              rel="noreferrer"
              style={styles.link}
            >
              UUID
            </a>{" "}
            –{" "}
            <a
              href="https://github.com/uuidjs/uuid?tab=MIT-1-ov-file#readme"
              target="_blank"
              rel="noreferrer"
              style={styles.link}
            >
              MIT License
            </a>
          </li>

          <li>
            <a
              href="https://github.com/ai/nanoid"
              target="_blank"
              rel="noreferrer"
              style={styles.link}
            >
              Nanoid
            </a>{" "}
            –{" "}
            <a
              href="https://github.com/ai/nanoid?tab=MIT-1-ov-file#readme"
              target="_blank"
              rel="noreferrer"
              style={styles.link}
            >
              MIT License
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
};

const styles = {
  page: {
    backgroundColor: "#f9f9f9",
    padding: "40px 0",
  },
  container: {
    maxWidth: "850px",
    margin: "0 auto",
    backgroundColor: "#ffffff",
    padding: "40px",
    fontFamily: "Arial, sans-serif",
    lineHeight: "1.8",
    color: "#333",
  },
  heading: {
    textAlign: "center",
    marginBottom: "30px",
    fontSize: "32px",
    fontWeight: "600",
  },
  subHeading: {
    marginTop: "25px",
    marginBottom: "15px",
    fontWeight: "600",
  },
  paragraph: {
    marginBottom: "20px",
    textAlign: "justify",
  },
  list: {
    marginLeft: "20px",
    marginBottom: "20px",
  },
  link: {
    color: "#1976d2",
    textDecoration: "none",
    fontWeight: "500",
  },
};

export default ThirdParty;